import TextList from './TextList';

export default TextList;
